import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
// NM 2024 theme
import Nm2024Theme from '../../nm2024Theme/colors';
// eslint-disable-next-line import/prefer-default-export
export const BulletedListNm2024 = styled(BulletedList)`
  && {
    padding-bottom: ${rem(28)};
    .nmx-p {
      font-family: 'Source Sans', 'Helvetica Neue', Helvetica, sans-serif;
      letter-spacing: ${rem(0.5)};
      color: ${Nm2024Theme.navy.navy};
    }
    .nmx-icon .icon-fill {
      stroke-width: 0; 
    }
  }
`;
